import React from "react";
import { Row, Col, Button, Space, message, Empty, Spin, Card } from "antd";
import logo from "assets/img/EBay_logo.svg";
import { APP_VERSION } from "constants/index";

const Unauthorized = () => {
  return (
    <>
      <main>
        <section id="notice-form">
          <Space
            align="center"
            direction="vertical"
            size={16}
            style={{ width: "100%" }}
          >
            <Card className="bg-transparent border-0">
              <div>
                <div className="text-center logo">
                  <img src={logo} alt="" height={100} />
                  <h2>Unauthorized</h2>
                </div>
                <div className="form-method">
                  <div className="form-content">
                    You are not authorized to access this application.
                  </div>
                  {/* <Button
                    onClick={login}
                    placement="right"
                    color="primary"
                    size="lg"
                    block
                  >
                    <span>Single Sign-On (SSO)</span>
                  </Button> */}
                </div>
              </div>
            </Card>
          </Space>
          <p className="footer-text">
            <p>v{APP_VERSION} by Brian K © 2023.</p>
          </p>
        </section>
      </main>
    </>
  );
};

export default Unauthorized;
